import { SearchOutlined } from "@mui/icons-material";
import { Autocomplete, TextField } from "@mui/material";
import { ProductMetadata } from "../../hooks/ProductApiHook";

interface ProductAutocompleteProps {
  products: Array<ProductMetadata>;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;

}

const ProductAutocomplete: React.FC<ProductAutocompleteProps> = ({ products, value, setValue }) => {

  return (
    <Autocomplete
      fullWidth
      value={value}
      options={products.map((product) => product.name)}
      onInputChange={(_, value) => setValue(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search"
          slotProps={{
            input: {
              ...params.InputProps,
              type: 'search',
              startAdornment: (
                <SearchOutlined />
              )
            },
          }}
        />
      )}
    />
  )
}

export default ProductAutocomplete;
